import { Component, OnInit } from '@angular/core';
import { UtilService } from '@app/utility/util.service';
import { ApiService } from '@app/utility/api.service';
import { MasterService } from '@app/utility/master.service';
import { Router, NavigationEnd } from "@angular/router";
import { Subscription } from 'rxjs';
import { timer } from 'rxjs/observable/timer'
import { environment } from '@env/environment';
import { TranslateService } from '@ngx-translate/core';

declare var $: any, moment: any;

@Component({
  selector: 'app-testndid',
  templateUrl: './testndid.component.html',
  styleUrls: ['./testndid.component.scss']
})
export class TestndidComponent implements OnInit {

  constructor(    
    private Api: ApiService,
    private Util: UtilService,
    private MasterService: MasterService,
    private router: Router,
    private translate: TranslateService
  ) { }


  Profile: any;
  Ticket: any;
  Contact: any;
  ContactDros: any;
  Editable: Boolean = false;
  CompanyType: any;
  PersonalType: any;
  DocGroupList: any;
  FileList: any = [];
  DocumentList: any = [];
  AcceptExtension: any;
  MaxTotalSizeMB: number;
  TotalFileSize: number = 0;
  InvestigateFlag: Boolean = false;
  AppealFlag: Boolean = false;

  PortalUser: any;

  OTPRefCode: string = "";
  ElapseTime: number = 0;
  TotalTime: number = 0;
  SubScr: Subscription;
  WaitTime: number;
  SubScr2: Subscription;

  masterStatus: any

  menuEnabled = false
  drosWeb: string = "";
  PathPdf: string = "";

  ngOnInit() {
    this.PortalUser = JSON.parse(localStorage.getItem("dpa_portal"));
    $('#dpa_contact_id').val(this.PortalUser.contactid);

  }

  
  async InvestigateAndAppealStatus() {
     this.router.navigate(["singlegatewaywait"]);
  }

  async InvestigateAndAppealCondition(UID: any) {
    if (!this.Util.IsNullOrUndefined(UID)) {
      let result: any = await this.Api.postCustomApi("SingleGateway", "GetRefID", { UID }); 
      if(!this.Util.IsNullOrUndefined(result) && result.length > 0  )
      {
        if (!this.Util.IsNullOrUndefined(result[0].authorizationUrl)) 
        {  
          this.drosWeb = result[0].authorizationUrl;
          $("#btnInvestigate").removeClass("sr-only");
        }
        else 
        {
          $("#btnInvestigate").addClass("sr-only");
        }
      }
      else 
      {
        $("#btnInvestigate").addClass("sr-only");
      }
    }
    else  {
      $("#btnInvestigate").addClass("sr-only");
    }
  }

  async CreateTable1() {
    this.router.navigate(["mainmenu/singlegatewaywait"]);
  }

  async OpenNDID()
  {

  }

}



// WEBPACK FOOTER //
// ./src/app/testndid/testndid.component.ts